<template>
    <div>
        <ts-page-title :title="$t('serviceTicket.pageTitle')" :breadcrumb="[
            { text: $t('home'), href: '/' },
            {
                text: $t('serviceTicket.pageTitle'),
                href: '/admin/service-tickets'
            },
            {
                text: $t('create'),
                active: true
            }
        ]" />
        <ts-panel>
            <ts-panel-wrapper>
                <ts-loading-banner :loading="loading">
                    <div class="row">
                        <div class="col-md-12">
                            <Info v-model="model" :validate="errors" />
                        </div>
                    </div>
                    <div class="row ts-pt-4">
                        <div class="col-md-12">
                            <Detail v-model="model" :validate="errors" class="ts-pt-6 ts-rounded" />
                        </div>
                    </div>
                    <div class="row ts-py-4">
                        <div class="col-md-12 ts-space-x-4 ts-flex ts-justify-end">
                            <ts-button @click.prevent="
                                $router.push({
                                    name: 'service-ticket'
                                })
                                ">
                                {{ $t('cancel') }}
                            </ts-button>
                            <ts-button color="primary" :waiting="loading" @click.prevent="onUpdate">
                                {{ $t('update') }}
                            </ts-button>
                        </div>
                    </div>
                </ts-loading-banner>
            </ts-panel-wrapper>
        </ts-panel>
    </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import Info from './components/info.vue'
import Detail from './components/detail.vue'
import { isEmpty } from 'lodash'
import { mapActions, mapState } from 'vuex'

export default {
    name: 'serviceTicketEdit',
    components: {
        Detail,
        Info
    },
    data() {
        return {
            errors: new Errors(),
            loading: false,
            src: null,
            model: {
                service_date: moment().format('DD-MM-YYYY'),
                customer_id: null,
                ticket_owner: null,
                ticket_status_id: 1,
                priority: 'normal',
                remarks: null,
                product_list: []
            }
        }
    },
    computed: {
        ...mapState('customerService/serviceTicket', ['edit_data', 'formViewDatas'])
    },
    methods: {
        ...mapActions('customerService/serviceTicket', ['find', 'getFormViewModel']),
        async fetchResources() {
            this.loading = true
            await this.find(this.$route.params.id)
                .then(() => {
                    let product_id = this.edit_data.repair_product_mains.map(el => el.product_id);
                    this.getFormViewModel({ params: { product_id: product_id }, index: undefined })
                })
                .then(() => {
                    this.setEditData()
                })
                .catch(error => {
                    this.$toasted.error(error.message)
                    this.errors = new Errors(error.errors)
                })
                .finally(() => {
                    this.loading = false
                })

        },
        onUpdate() {
            this.loading = true
            this.errors = new Errors()
            this.$store
                .dispatch('customerService/serviceTicket/update', {
                    id: this.$route.params.id,
                    data: this.model
                })
                .then(response => {
                    this.notice({
                        type: 'success',
                        text: response.message
                    })
                    this.$router.push({ name: 'service-ticket' })
                })
                .catch(error => {
                    this.errors = new Errors(error.errors)
                    this.notice({ type: 'error', text: error.message })
                })
                .finally(() => {
                    this.loading = false
                })
        },
        setEditData() {
            if (!isEmpty(this.edit_data)) {
                this.model.service_date = moment(this.edit_data.service_date, 'DD-MM-YYYY').format('DD-MM-YYYY')
                this.model.customer_id = this.edit_data.customer_id
                this.model.ticket_owner = this.edit_data.ticket_owner
                this.model.ticket_status_id = this.edit_data.ticket_status_id
                this.model.remarks = this.edit_data.remarks
                this.model.product_list = this.edit_data.repair_product_mains
            }
        },
        clearInput() {
            this.errors = new Errors()
            this.model.service_date = moment().format('DD-MM-YYYY')
            this.model.customer_id = null
            this.model.ticket_owner = null
            this.model.ticket_status_id = 1
            this.model.priority = 'normal'
            this.model.remarks = null
            this.model.product_list = []
        },
        notice(not) {
            this.$Notice[not.type]({
                title: 'SERVICE TICKET',
                desc: not.text
            })
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.fetchResources()
        })
    },
    beforeRouteLeave(to, from, next) {
        this.$store.commit('customerService/serviceTicket/RESET_STATE')
        next()
    }
}
</script>
